import React, { Component } from 'react';
import { Spin, Popover } from 'antd';
import CommonCharts from '../../../components/Charts';
import Fetch from '../../../../../common/Fetch';
import ExportUtil from '../../../../../common/ExportUtil';

const GraphicType = 0;
const Colors = {
    "colors10":["#5B8FF9","#61DDAA","#65789B","#F6BD16","#7262fd","#78D3F8","#9661BC","#F6903D","#008685","#F08BB4"],
    "colors20":["#5B8FF9","#CDDDFD","#61DDAA","#CDF3E4","#65789B","#CED4DE","#F6BD16","#FCEBB9","#7262fd","#D3CEFD","#78D3F8","#D3EEF9","#9661BC","#DECFEA","#F6903D","#FFE0C7","#008685","#BBDEDE","#F08BB4","#FFE0ED"]
};

class PieChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            negativeList: [],
            loading: false,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { searchParams: nextSearchParams } = nextProps;
        const { searchParams } = this.props;
        if (nextSearchParams !== searchParams) {
            return false;
        }
        return true;
    }

    componentDidMount() {
        this.loadData();
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.load !== this.props.load) {
            this.loadData();
        }
    }

    loadData = () => {
        const { searchParams, queryUrl, countType } = this.props;

        this.setState({ loading: true });
        Fetch.post(queryUrl, {
            countType,
            GraphicType,
            ...searchParams,
        }).then(res => {
            const { data, negativeList } = res;
            this.setState({
                data,
                negativeList,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    handleClick = () => {
        const { searchParams, exportUrl, countType } = this.props;
        ExportUtil.export({ ...searchParams, countType, GraphicType }, null, exportUrl);
    }

    genNegativeDom = () => {
        const { negativeList } = this.state;
        if (!(negativeList || []).length) return;

        const item = (negativeList || []).map((i, x) =>
            <div key={x}>
                <span
                    // style={{ display: 'inline-block', width: 80, textAlign: 'right' }}
                >{i.condition}：</span>
                {i.amountTotal}
            </div>
        );
        return (
            <Popover
                placement="top"
                overlayClassName="contract-pop"
                content={<div>{item}</div>}
            >
                <span className="negative">负值金额</span>
            </Popover>
        );
    }

    render() {
        const { title, height, filename } = this.props;
        const { data, loading } = this.state;
        const chartData = (data || []).map((item, index) => {
            const { percentageStatisticData, condition } = item;
            const number = index + 1;
            return {
                name: `${number}: ${condition}`,
                number,
                y: Number(percentageStatisticData),
            };
        });
        const colors = chartData.length > 10 ? Colors.colors20 : Colors.colors10;
        return (
            <div className="chart-content">
                <Spin spinning={loading}>
                    <p className="chart-title">{title}</p>
                    <CommonCharts
                        isPie={true}
                        negativeMoney={this.genNegativeDom()}
                        type='pie'
                        height={height}
                        filename={filename}
                        plotOptions={{
                            pie: {
                                allowPointSelect: true,
                                cursor: 'pointer',
                                colors,
                                dataLabels: {
                                    enabled: true,
                                    formatter: function () {
                                        return this.y >= 3 ? `<b>${this.point.number}</b>: ${(this.point.y).toFixed(2)} %` : null;
                                    },
                                    style: { color: 'black', textOutline: 'none' },
                                    distance: -20
                                },
                                tooltip: {
                                    headerFormat: '',
                                    pointFormat: '<b>{point.number}</b>: {point.y:.2f} %',
                                },
                                showInLegend: true
                            }
                        }}
                        series={[{
                            name: title,
                            colorByPoint: true,
                            data: chartData
                        }]}
                        onClick={this.handleClick}
                    />
                </Spin>
            </div>
        );
    }
}

export default PieChart;



// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestToDo/components/ChartsCollection/PieChart.js